










import { Component, Prop, Vue } from "vue-property-decorator";

import ListItem from "@/components/common/list/ListItem.vue";
import ListItemRowNohover from "@/components/common/list/ListItemRowNohover.vue";
import { ImportantMessageInterface } from "@/interfaces/important-message.interface";

@Component({
  components: { ListItem, ListItemRowNohover },
})
export default class ImportantOldListItem extends Vue {
  @Prop({ required: true }) message!: ImportantMessageInterface;
}
